<script>
    /**
     * SPDX-FileCopyrightText: 2012-2026 Open Assessment Technologies S.A.
     * Copyright (C) 2026 (original work) Open Assessment Technologies S.A.
     *
     * SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-TAO-Commercial-License
     */
    import ChoiceContent from './ChoiceContent.svelte';
    import { __ } from '@oat-sa-private/ui-core';

    let { otherChoice, instructionsLang } = $props();
</script>

<span class="visually-hidden">
    {#if otherChoice}
        <span lang={instructionsLang}>
            {__('Associated with')}
        </span>
        <ChoiceContent choice={otherChoice} />
    {:else}
        <span lang={instructionsLang}>{__('No association.')}</span>
    {/if}
</span>
